import { Action, createReducer, on } from '@ngrx/store';

import { Additional } from '../../pages/additionals/additional';
import { Category } from '../../pages/categories/category';
import { Label } from '../../classes/label';
import { Order } from '../../pages/orders/order';
import { Product } from '../../pages/products/product';
import { Subcategory } from '../../pages/subcategories/subcategory';
import * as ordersActions from '../actions/orders.actions';

export interface OrderState {
  selected: Order;
  category: Category[];
  subcategoryStack: Map<string, Subcategory[]>;
  productStack: Map<string, Product[]>;
  additionalStack: Map<string, Additional[]>;
  labelNotesStack: Map<string, Label[]>;
}

const orderInitState: OrderState = {
  selected: null,
  category: null,
  subcategoryStack: null,
  productStack: null,
  additionalStack: null,
  labelNotesStack: null

};

const _orderReducer = createReducer(orderInitState,
  on(ordersActions.selectOrder, (state: OrderState, { order }) => ({
    ...state,
    selected: { ...order }
  })),
  on(ordersActions.unSelectOrder, (state: OrderState) => ({
    ...state,
    selected: null
  })),
  on(ordersActions.setCategoryList, (state: OrderState, { category }) => ({
    ...state,
    ...category
  })),
  on(ordersActions.setSubcategyStack, (state: OrderState, { subcategoryStack }) => ({
    ...state,
    subcategoryStack
  })),
  on(ordersActions.setProductStack, (state: OrderState, { productStack }) => ({
    ...state,
    productStack
  })),
  on(ordersActions.setAdditionalStack, (state: OrderState, { addStack }) => ({
    ...state,
    addStack
  })),
  on(ordersActions.setLabelNotesStack, (state: OrderState, { labelNotesStack }) => ({
    ...state,
    labelNotesStack
  }))
);

export function OrdersReducer(state: OrderState, action: Action): any {
  return _orderReducer(state, action);
}
